// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"487b3666","320":"6e2e3e70","457":"8954869f","466":"85abcb31","522":"f42c7557","679":"08dca797","794":"502821ba","963":"8671a115","990":"fb9a14d6","993":"57ce7933"}[chunkId] + ".chunk.js";
};